/*
  RightSidebar.jsx
*/

// Npm.
import React from 'react';

// Components.
import Sidebar from '../../../components/Sidebar';
import NodeForm from './NodeForm';
import LinkForm from './LinkForm';
import DefaultForm from './DefaultForm';

/**
 * Right sidebar component.
 */
export default function RightSidebar({
  className,
  open = false,
  disabled = false,
  isSmall = false,
  selectedLink,
  selectedNode,
  graphData,
  onClose,
  onChangeGraphData,
  onChangeSelectedNode,
  onChangeSelectedLink,
  ...rest
}) {

  // Props.

  let title = 'Menu';
  if (selectedNode) {
    title = 'Node';
  } else if (selectedLink) {
    title = 'Link';
  }

  // Enable clear button to allow users to return to the main menu
  // without having to click the background.

  const handleCancel = selectedLink != null || selectedNode != null ? () => {
    if (onChangeSelectedNode) {
      onChangeSelectedNode(null);
    }
    if (onChangeSelectedLink) {
      onChangeSelectedLink(null);
    }
  } : undefined;

  // NOTE: I forget why "keepMounted" was added to this.
  // Maybe to keep a dialog visible while the sidebar is closed?

  return (
    <Sidebar
      className={className}
      title={title}
      position="right"
      variant={isSmall ? 'temporary' : 'permanent'}
      open={open}
      onClose={onClose}
      onCancel={handleCancel}
      disabled={disabled}
      keepMounted
    >
      <div>
        {
          selectedNode != null &&
          <NodeForm
            node={selectedNode}
            graphData={graphData}
            onChangeGraphData={onChangeGraphData}
            onChangeSelectedNode={onChangeSelectedNode}
            disabled={disabled}
          />
        }
        {
          selectedLink != null &&
          <LinkForm
            link={selectedLink}
            graphData={graphData}
            onChangeGraphData={onChangeGraphData}
            onChangeSelectedLink={onChangeSelectedLink}
            disabled={disabled}
          />
        }
        {
          !selectedNode && !selectedLink &&
          <DefaultForm
            graphData={graphData}
            onChangeGraphData={onChangeGraphData}
            onChangeSelectedNode={onChangeSelectedNode}
            disabled={disabled}
          />
        }
      </div>
    </Sidebar>
  );
}
